var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,12.5c0,4.136-3.364,7.5-7.5,7.5H1.293l3.146,3.146c.195,.195,.195,.512,0,.707-.098,.098-.226,.146-.354,.146s-.256-.049-.354-.146L.439,20.561c-.585-.585-.585-1.536,0-2.121l3.293-3.293c.195-.195,.512-.195,.707,0s.195,.512,0,.707l-3.146,3.146h15.207c3.584,0,6.5-2.916,6.5-6.5,0-.276,.224-.5,.5-.5s.5,.224,.5,.5ZM.5,12c.276,0,.5-.224,.5-.5,0-3.584,2.916-6.5,6.5-6.5h15.207l-3.146,3.146c-.195,.195-.195,.512,0,.707,.098,.098,.226,.146,.354,.146s.256-.049,.354-.146l3.293-3.293c.585-.585,.585-1.536,0-2.121L20.268,.146c-.195-.195-.512-.195-.707,0s-.195,.512,0,.707l3.146,3.146H7.5C3.364,4,0,7.364,0,11.5c0,.276,.224,.5,.5,.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatIcon);
export default __webpack_public_path__ + "static/media/repeatIcon.9ee28521a5721612a097f73a64a522ec.svg";
export { ForwardRef as ReactComponent };